import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

// Utils
import { closePopup } from '../components/popupPanel/popupActions';
import quickNotesPopupStayActivePredicate from '../workspace/header/workspaceToolsHeader/quickNotes/popup/quickNotesPopupStayActivePredicate';

// Selectors
import { sharedBoardsPopupSelector } from '../workspace/sidebar/sidebarSelector';

// Actions
import * as boardService from '../element/board/boardService';

// Decorators
import renderListPlaceholdersDecorator from '../element/elementPlaceholder/renderListPlaceholdersDecorator';
import elementShortcutsDecorator from '../workspace/shortcuts/clipboard/elementShortcutsDecorator';

// Components
import PopupTrigger from '../components/popupPanel/PopupTrigger';
import SidebarPopupContent from './SidebarPopupContent';

// Constants
import { PopupIds, PopupSections } from '../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    closePopupPanel: () => dispatch(closePopup(PopupIds.SHARED_WITH_YOU)),
    fetchBoard: (boardId) =>
        dispatch(
            boardService.fetchBoard({
                boardId,
                excludeSelf: false,
                loadAncestors: false,
            }),
        ),
});

@connect(sharedBoardsPopupSelector, mapDispatchToProps)
@renderListPlaceholdersDecorator
@elementShortcutsDecorator
class SharedBoardsPopupUtil extends React.Component {
    componentDidMount() {
        const { rootId, fetchBoard } = this.props;
        if (!rootId) return;

        fetchBoard(rootId);
    }

    componentDidUpdate(prevProps) {
        const { closePopupPanel, childIds } = this.props;

        if (prevProps.childIds.length > 0 && childIds.length === 0) {
            closePopupPanel();
        }
    }

    render() {
        const { onPopupToggle, rootId, connectDropTarget, canDrop, isHovered, childIds } = this.props;

        if (!rootId) return null;

        return (
            <div className={classNames('SharedUtil', { 'can-drop': canDrop, hovered: isHovered })}>
                <div ref={connectDropTarget} className="drop-target-wrapper">
                    <PopupTrigger
                        popupId={PopupIds.SHARED_WITH_YOU}
                        className="button-quick-notes header-util-button"
                        stayActivePredicate={quickNotesPopupStayActivePredicate}
                        closeSection={PopupSections.HEADER}
                        onToggle={onPopupToggle}
                    >
                        {(popupOpen) => (
                            <div className="button-content">
                                <div className="SidebarItemTitle">Shared with you</div>
                                <div className="SidebarItemCount"> {childIds.length > 0 ? childIds.length : ''}</div>
                            </div>
                        )}
                    </PopupTrigger>
                </div>
                <SidebarPopupContent
                    {...this.props}
                    popupId={PopupIds.SHARED_WITH_YOU}
                    popupClassName="SharedPopup"
                    listCanDropFn={() => false}
                />
            </div>
        );
    }
}

SharedBoardsPopupUtil.propTypes = {
    tooltipEnabled: PropTypes.bool,
    popupOpen: PropTypes.bool,
    canDrop: PropTypes.bool,
    isHovered: PropTypes.bool,
    rootId: PropTypes.string,
    childIds: PropTypes.array,
    fetchBoard: PropTypes.func,
    connectDropTarget: PropTypes.func,
    onPopupToggle: PropTypes.func,
    closePopupPanel: PropTypes.func,
    element: PropTypes.object,
    elementId: PropTypes.string,
};

export default SharedBoardsPopupUtil;
